import { createSlice } from "@reduxjs/toolkit";

const initialState = { drafts: {} };

const salesDraftsSlice = createSlice({
  name: "salesDrafts",
  initialState,
  reducers: {
    saveSalesDraft(state, action) {
      const key = String(action.payload?.key || "").trim();
      const draft = action.payload?.draft;
      if (!key || !draft || typeof draft !== "object" || Array.isArray(draft)) {
        return;
      }
      state.drafts[key] = {
        ...draft,
        updatedAt: new Date().toISOString(),
      };
    },

    removeSalesDraft(state, action) {
      const key = String(action.payload?.key || action.payload || "").trim();
      if (!key) return;
      delete state.drafts[key];
    },

    clearAllSalesDrafts(state) {
      state.drafts = {};
    },
  },
});

export const persistSalesDraftsState = (salesDraftsState) => {
  void salesDraftsState;
};

export const { saveSalesDraft, removeSalesDraft, clearAllSalesDrafts } = salesDraftsSlice.actions;
export default salesDraftsSlice.reducer;
